import { Button } from '@repo/shadcn';
import { Link } from 'react-router-dom';

import { DataTable } from '@components/ui/data.table/data-table';
import { SectionError } from '@components/ui/error';
import PageHeading from '@components/ui/heading/page-headeing';
import { SectionLoader } from '@components/ui/loader';

import { Route } from '@/constants';
import { salesReturnListColumn } from '@/modules/sales-return/sales-return-list/sales-return-list.column';
import {
    SalesReturnListProvider,
    useSalesReturnListContext,
} from '@/modules/sales-return/sales-return-list/sales-return-list.context';

const SalesReturnListComponent = () => {
    const { data, isLoading, isError, error, isFetching } =
        useSalesReturnListContext();

    if (isLoading) {
        return <SectionLoader />;
    }

    if (isError) {
        return <SectionError error={error} fallbackPath={Route.DASHBOARD} />;
    }

    return (
        <>
            <div className={'mb-4 flex items-center justify-between '}>
                <PageHeading
                    title={'Sales Return'}
                    subTitle={'View your sales returns'}
                />
                <div>
                    <Link to={Route.SALES_RETURN_CREATE}>
                        <Button type={'button'}>Add Sales Return</Button>
                    </Link>
                </div>
            </div>

            <DataTable
                data={data?.data || []}
                isLoading={isLoading || isFetching}
                columns={salesReturnListColumn}
            />
            {/*<DataViewer data={data} />*/}
        </>
    );
};

export const SalesReturnList = () => {
    return (
        <SalesReturnListProvider>
            <SalesReturnListComponent />
        </SalesReturnListProvider>
    );
};

SalesReturnList.displayName = 'SalesReturnList';
